<template>
  <nav class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <div class="m-header"><a href="#" class="b-brand text-primary"><img src="@/assets/img/logo/logo.png"
            class="img-fluid logo-lg" alt="logo"></a></div>
      <div class="navbar-content pc-trigger simplebar-scrollable-y" data-simplebar="init">
        <div class="simplebar-wrapper">
          <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
          </div>
          <div class="simplebar-mask">
            <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
              <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content"
                style="height: 100%; overflow: hidden scroll;">
                <div class="simplebar-content" style="padding: 10px 0px;">
                  <div class="card pc-user-card">
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0"><img src="@/assets/img/core/avatar.png" style="width: 45px;"
                            alt="user-image" class="user-avtar wid-45 rounded-circle"></div>
                        <div class="flex-grow-1 ms-1 me-1">
                          <h6 class="mb-0">Việt Nhật</h6><small data-i18n="Administrator">Administrator</small>
                        </div><a class="btn btn-link-secondary avtar" data-bs-toggle="collapse"
                          href="#pc_sidebar_userlink"><i class="fa fa-solid fa-bars-staggered"></i></a>
                      </div>
                      <div class="collapse pc-user-links" id="pc_sidebar_userlink">
                        <div class="pt-3"><a href="#!"><i class="ti ti-user"></i> <span data-i18n="My Account">My
                              Account</span> </a><a href="#!"><i class="ti ti-settings"></i> <span
                              data-i18n="Settings">Settings</span> </a><a href="#!"><i class="ti ti-lock"></i> <span
                              data-i18n="Lock Screen">Lock Screen</span> </a><a href="#!"><i class="ti ti-power"></i>
                            <span data-i18n="Logout">Logout</span></a></div>
                      </div>
                    </div>
                  </div>
                  <ul class="pc-navbar" style="display: block;">
                    <li class="pc-item pc-caption"><label data-i18n="Navigation">Menu Admin</label></li>
                    <li v-for="(item, index) in listMenu" :key="index.id" class="pc-item pc-hasmenu"
                      :class="{ 'active': openMenu === item.id }">
                      <a href="#" class="pc-link" @click.prevent="toggleMenu(item)">
                        <span class="pc-micon"><i :class="item.icon"></i></span>
                        <span class="pc-mtext">{{ item.name }}</span>
                        <span class="pc-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                            <polyline points="9 18 15 12 9 6"></polyline>
                          </svg></span>
                      </a>

                      <ul v-if="item.children" v-show="openMenu === item.id" class="submenu">
                        <li v-for="child in item.children" :key="child.id">
                          <router-link v-if="child.link" :to="child.link" class="pc-link">
                            <span class="pc-micon"><i :class="child.icon"></i></span>
                            <span class="pc-mtext">{{ child.name }}</span>
                          </router-link>
                          <span v-else class="pc-link disabled">{{ child.name }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </nav>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
      reportsMenuData: false,
      authenticationMenuData: false,
      errorMenuData: false,
      formMenuData: false,
      tablesMenuData: false,
      multilevelMenuData: false,
      activeClass: "active",

      listMenu: [],
      activeMenus: {}, // lưu trạng thái mở/tắt
      openMenu: null // ID menu đang mở
    };
  },
  methods: {
    // toggleMenu(id) {
    //   this.activeMenus[id] = !this.activeMenus[id];
    // },
    toggleMenu(item) {
      if (this.openMenu === item.id) {
        this.openMenu = null
      } else {
        this.openMenu = item.id
      }
    },
    hasItems(item) {
      return Array.isArray(item.children) && item.children.length > 0;
    },
    isCheck(link) {
      return `/${this.$route.name}` === link;
    },
    scrollHanle(evt) { },
    togglereportsMenu() {
      this.reportsMenuData = !this.reportsMenuData;
    },
    toggleauthenticationMenu() {
      this.authenticationMenuData = !this.authenticationMenuData;
    },
    toggleerrorMenu() {
      this.errorMenuData = !this.errorMenuData;
    },
    toggleformsMenu() {
      this.formsMenuData = !this.formsMenuData;
    },
    toggletablesMenu() {
      this.tablesMenuData = !this.tablesMenuData;
    },
    togglemultilevelMenu() {
      this.multilevelMenuData = !this.multilevelMenuData;
    },
    isCustomDropdown() {
      //Search bar
      var searchOptions = document.getElementById("search-close-options");
      var dropdown = document.getElementById("search-dropdown");
      var searchInput = document.getElementById("search-options");

      searchInput.addEventListener("focus", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#sidebar")) {
          let a = document
            .querySelector("#sidebar")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              );
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show");
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 1000);
    },

    handleGetIdMenu(path) {

      this.$router.push(path);
    },
  },
  components: {
    PerfectScrollbar,
  },
  created() {
    const currentUser = localStorage.getItem("auth-user");
    if (currentUser) {
      const data = JSON.parse(currentUser);
      if (data?.menu) {
        this.listMenu = data.menu;
        data.menu.forEach(item => {
          this.activeMenus[item.id] = false;

          // Tự động mở nếu có router hiện tại
          if (item.children?.some(child => child.link === this.$route.path)) {
            this.openMenu = item.id;
          }
        });
      }
    }
  },
  computed: {
    currentPath() {
      //  console.log("LOG :  ", this.$route.name)
      return this.$route.name;
    },
    reportsMenu() {
      return (
        this.$route.name == "admin/invoice-report" || this.$route.name == "admin/invoice"
      );
    },
    authenticationMenu() {
      return (
        this.$route.name == "admin/forgot-password" ||
        this.$route.name == "admin/lock-screen" ||
        this.$route.name == "admin/login" ||
        this.$route.name == "admin/register"
      );
    },

    errorMenu() {
      return (
        this.$route.name == "admin/error-404" || this.$route.name == "admin/error-500"
      );
    },
    tablesMenu() {
      return (
        this.$route.name == "admin/data-tables" ||
        this.$route.name == "admin/tables-basic"
      );
    },

    formsMenu() {
      return (
        this.$route.name == "admin/form-basic-inputs" ||
        this.$route.name == "admin/form-input-groups" ||
        this.$route.name == "admin/form-horizontal" ||
        this.$route.name == "admin/form-mask" ||
        this.$route.name == "admin/form-validation" ||
        this.$route.name == "admin/form-vertical"
      );
    },

    multilevelMenu() { },
  },

};
</script>
